module.exports = __webpack_public_path__ + "static/media/356.27e7cc2f.svg";